import React from 'react'

// ─────────────────────────────────────────────────────────────────────────────
// PageHero , centered intro block used at the top of every v2 admin page.
//
//   <PageHero
//     icon={Activity}
//     kicker="Allgemein"
//     title="Nutzer-Aktivitäten"
//     caption="Übersicht der aktuellsten Aktivitäten und Plattform-Signale."
//   />
//
// One source of truth for the page-hero pattern: peach-haloed icon medallion
// on a hairline-bordered white square, small uppercase orange kicker, big
// display headline (28–32 px / 600 / tight tracking), short caption below.
//
// When all consumers use this component, any future tweak (typography,
// spacing, medallion treatment) ripples across the whole admin.
// ─────────────────────────────────────────────────────────────────────────────

export function PageHero({
  icon: Icon,
  kicker,
  title,
  caption,
  className = '',
  align = 'center',  // 'center' | 'left'
  marginBottom = 'md',  // 'sm' | 'md' | 'lg'
}) {
  const mb = marginBottom === 'sm' ? 'mb-5' : marginBottom === 'lg' ? 'mb-10' : 'mb-8'
  const alignCls = align === 'left' ? 'text-left' : 'text-center'
  const medallionMargin = align === 'left' ? 'mb-3' : 'mx-auto mb-3'
  return (
    <header className={alignCls + ' ' + mb + (className ? ' ' + className : '')}>
      {Icon && (
        <span
          className={
            'grid place-items-center w-[52px] h-[52px] rounded-[14px] bg-white border border-[#e7e5df] ' +
            medallionMargin
          }
          style={{ boxShadow: '0 1px 2px rgba(20,20,16,.03), 0 12px 36px -16px rgba(232,93,31,.30), 0 0 0 4px #fff1e8' }}
        >
          <Icon size={22} strokeWidth={1.6} className='text-[#e85d1f]'/>
        </span>
      )}
      {/* The `kicker` prop is intentionally ignored: the page category is
          already shown in the admin sidebar, so repeating it above every
          h1 was redundant. Kept the prop in the signature so existing
          call sites don't need editing. */}
      {title && (
        <h1 className='m-0 text-[28px] md:text-[32px] font-semibold tracking-[-0.022em] text-[#1a1816] leading-[1.1]'>
          {title}
        </h1>
      )}
      {caption && (
        <p
          className={
            'm-0 mt-2 text-[13.5px] text-[#6b6862] leading-relaxed ' +
            (align === 'center' ? 'max-w-[52ch] mx-auto' : 'max-w-[60ch]')
          }
        >
          {caption}
        </p>
      )}
    </header>
  )
}
